var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('LayoutBase',[_c('div',{staticClass:"container"},[_c('h2',[_vm._v("Your posts")]),_vm._v(" "),_c('div',{staticClass:"panel"},[_c('ListPosts')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }